import { Pagination } from 'components/shared/Blotter/Pagination/Pagination';
import type {
  PaginationDispatchProps,
  PaginationStateProps,
} from 'components/shared/Blotter/Pagination/Pagination.model';
import { connect } from 'react-redux';
import {
  dailyBlotterItemsPerPageChanged,
  dailyBlotterPageChanged,
} from 'state/blotters/dailyBlotter/dailyBlotter.action';
import { getDailyBlotterPaginationInfo } from 'state/blotters/dailyBlotter/dailyBlotter.selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export const mapStateToProps = (state: AppState): PaginationStateProps => {
  const { page, totalElements: totalItems, totalPages, itemsPerPage } = getDailyBlotterPaginationInfo(state);
  return { page, totalItems, totalPages, itemsPerPage, isSmall: true };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): PaginationDispatchProps => ({
  onPageChanged(page: number) {
    dispatch(dailyBlotterPageChanged(page));
  },
  onSizeChanged(size) {
    dispatch(dailyBlotterItemsPerPageChanged(size, 1));
  },
});

const connectDailyBlotterPaginationComponent = connect(mapStateToProps, mapDispatchToProps);

export const DailyBlotterPagination = connectDailyBlotterPaginationComponent(Pagination);
